module.exports = __webpack_public_path__ + "static/media/light-07.e39b61de.jpg";